import type { ColumnDef } from '@tanstack/react-table';
import { i18nKeys } from 'locales/index';
import { useTranslation } from 'locales/logic';
import { useMemo } from 'react';

import type { LightAutomation } from '../../../../api';
import {
  ActionIconsCell,
  DescriptionCell,
  DragHandleCell,
  LastRunAtCell,
  NameCell,
  TargetModelCell,
} from '../components';

export function useAutomationTableColumns(
  handleEditAutomation: (id: string) => void,
  handleDeleteAutomation: (id: string) => void,
) {
  const { t } = useTranslation();

  return useMemo<Array<ColumnDef<LightAutomation>>>(
    () => [
      { id: 'drag-handle', cell: DragHandleCell, size: 60 },
      {
        accessorKey: 'name',
        header: t(i18nKeys.AUTOMATION.COLUMNS.NAME),
        cell: ({ row }) => <NameCell name={row.original.name} />,
      },
      {
        accessorKey: 'description',
        header: t(i18nKeys.AUTOMATION.COLUMNS.DESCRIPTION),
        cell: ({ row }) => <DescriptionCell description={row.original.description} />,
      },
      {
        accessorKey: 'targetModel',
        header: t(i18nKeys.AUTOMATION.COLUMNS.MODEL),
        cell: ({ row }) => <TargetModelCell model={row.original.targetModel} />,
      },
      {
        accessorKey: 'lastRunAt',
        header: t(i18nKeys.AUTOMATION.COLUMNS.LAST_RUN_AT),
        cell: ({ row }) => <LastRunAtCell lastRunAt={row.original.lastActivityAt} />,
      },
      {
        accessorKey: 'actions',
        header: t(i18nKeys.AUTOMATION.COLUMNS.ACTIONS),
        cell: row => (
          <ActionIconsCell
            automation={row.row.original}
            handleDeleteAutomation={handleDeleteAutomation}
            setEditAutomation={handleEditAutomation}
          />
        ),
      },
    ],
    [handleDeleteAutomation, handleEditAutomation, t],
  );
}
